import React, {useEffect, useState} from "react";
import {getUtenteFromToken} from "../utility/common";
import {callRefreshToken} from "../features/login/services/AuthServices";

export const AuthContext = React.createContext('');

export const AuthProvider = ({value, children}) => {

    const [user, setUser] = useState()
    const [inizializing, setInizializing] = useState(true)
    const [annoCorrenteDefault, setAnnoCorrenteDefault] = useState(false);
    const [annoSelKpi, setAnnoSelKpi] = useState(new Date().getFullYear());

    async function checkLogin() {
        const accessToken = localStorage.getItem('ns-access-token');
        let user = accessToken && accessToken !== '' ? getUtenteFromToken(accessToken) : null;

        if (!user) {
            // Se non riesco a recuperare l'utente dall'access token controllo, se ho un refresh token, provo a refreshare i due token
            const refreshToken = localStorage.getItem('ns-refresh-token');
            if (refreshToken && refreshToken !== '') {
                const usr = getUtenteFromToken(refreshToken);
                let responseRefreshToken = await callRefreshToken(usr.id_utente, refreshToken);

                if (responseRefreshToken?.data && responseRefreshToken?.data?.result === 0) {
                    // Aggiorna i token
                    localStorage.setItem('ns-refresh-token', responseRefreshToken.data.data.refresh_token);
                    localStorage.setItem('ns-access-token', responseRefreshToken.data.data.access_token);

                    user = getUtenteFromToken(responseRefreshToken.data.data.access_token);
                }
            }
        }

        setUser(user);
        setInizializing(false);
    }

    useEffect(() => {
        checkLogin()

        // Se ho un anno nel local storage, lo setto nell'Hook. Altrimenti setto nel local storage l'anno corrente
        let annoMem = localStorage.getItem('ns-anno-kpi');
        if (annoMem && annoMem !== '') {
            setAnnoKpi(parseInt(annoMem));
        } else {
            let annoCorrente = new Date().getFullYear();
            setAnnoSelKpi(annoCorrente);
            setAnnoCorrenteDefault(true);
        }
    }, []);

    const handleLogin = (user, history, hash) => {
        setUser(user);
        setInizializing(false);
        if (hash && hash !== '') {
            history.push(hash)
        } else {
            history.push('/home')
        }
    }

    const handleLogout = () => {
        localStorage.removeItem('ns-access-token');
        localStorage.removeItem('ns-refresh-token')
        localStorage.removeItem('ns-anno-kpi');
        setUser(null);
        setInizializing(false);
    }

    const isLogged = () => {
        if (inizializing === false) {
            return (user && user !== '') ? true : false;
        } else {
            return null;
        }
    }

    const setAnnoKpi = (anno) => {
        let a = parseInt(anno)
        localStorage.setItem('ns-anno-kpi', a);
        return setAnnoSelKpi(a);
    }

    return (
        <AuthContext.Provider
            value={{
                user,
                inizializingUser: inizializing,
                handleLogin,
                handleLogout,
                isLogged,
                annoKpi: annoSelKpi,
                setAnnoKpi,
                setAnnoSelKpi,
                annoCorrenteDefault
            }}>{children}</AuthContext.Provider>
    );
};
